import i18n from "i18next";
import {Card} from "@/Components/Card";
import ManageSubscriptionsModal from "@/Pages/Manage/ManageSubscriptionsModal";

export default function SubscriptionsCard({props, state, dispatch, modules, bundles, openCancellationRequestModal, dataTestid}) {

    const features = props.features;

    return (
        <div data-testid={'subscription-card-div-'+dataTestid} className="row">
            <Card className="subscriptions-card col">
                <div className="subscriptions-card-header">
                    <span className="subscriptions-card-title">{i18n.t("admin-account-overview.subscription-overview")}</span>
                    {(props.allowCancelSubscription && features['checkout'])
                        && <span data-testid={'cancel_subscription-span-'+dataTestid} className="edit-subscription"
                        onClick={() => openCancellationRequestModal()}
                    >{i18n.t("admin-account-overview.cancel-subscription")}</span>}
                </div>
                <div className="subscriptions-card-body">
                    <span className="subscription-bundles-container">
                        <span className="subscriptions-bundles-svg"><img src="/images/my-bundle.svg"/></span>
                        <div>
                            <div className="my-bundle">{i18n.t("admin-account-overview.bundle")}</div>
                                {bundles.length > 0 ? bundles.map((bundle, index) => {
                                    return <div key={index}>
                                        {(bundle.trial && bundle.trial["expired_trial"]) ? <span data-testid={'expired_trial_icon-span-'+ dataTestid} className="fas fa-clock"/> : <span data-testid={'active_icon-span-'+dataTestid} className="far fa-check"/>}
                                        <span className="bundle-name">{bundle.name}</span>
                                    </div>
                                }) :
                                    <span className="bundle-name">{i18n.t("admin-account-overview.no-active-bundle")}</span>
                                }
                        </div>
                    </span>
                    <span className="subscription-modules-container">
                        <span className="subscriptions-modules-svg"><img src="/images/my-modules.svg"/></span>
                        <div>
                            <div className="my-modules">{i18n.t("admin-account-overview.modules")}</div>
                            <div>{modules.length > 0 ? modules.map((module, key) => {
                                return <div data-testid={'modules-div-'+dataTestid+'-'+module.name} key={key}>
                                    {(module.trial && module.trial["expired_trial"]) ? <span className="fas fa-clock"/> : <span className="far fa-check"/>}
                                    <span className="module-name">{module.sales_name ?? module.name}</span>
                                </div>
                            }) :
                                <span className="module-name">{i18n.t("admin-account-overview.no-active-modules")}</span>
                            }
                            </div>
                        </div>
                    </span>
                </div>
            </Card>
            { state.manageSubscriptionsModal &&
                <ManageSubscriptionsModal
                    props={props}
                    state={state}
                    dispatch={dispatch}
                />
            }
        </div>
    )
}
